export default __webpack_public_path__ + "static/media/honmuraan.3dcff2ec.jpeg";